module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-panel flip-container",
    class: {
      open: _vm.isOpen, flipped: _vm.isFlipped
    }
  }, [_c('div', {
    staticClass: "flipper",
    class: {
      immediate: _vm.isImmediate
    }
  }, [_c('div', {
    staticClass: "front"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "delete is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }), _vm._v(" "), _vm._t("front")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    staticClass: "delete is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }), _vm._v(" "), _vm._t("back")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571fd320","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideOut.vue
// module id = 115
// module chunks = 3 4 5 6 7 8 9 10 11 12 13 16 18 27